/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-07 11:21:35
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-24 16:11:37
 */
import { Button, Col, Form, Input, Popover, Row, Select, Space } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../compnents/form/DateSelect'
import { Categories, Category, CategoryName } from '../../models/category'
import { User } from '../../models/user'
import { InventoryChangeParams } from '../../services/InventChange'
import { getStorage, selectStorage } from '../durgsystem/durgsystemSlice'
import {
  getDepartment,
  sleectUserData,
} from '../putstorelist/putstorelistSlice'
import styles from './InventoryChange.module.css'
import { head, tail } from 'lodash'
import { useLocation } from 'react-router-dom'
import { selectTenantCategory } from '../../app/applicationSlice'
import { FilterIconOutlined } from '../../compnents/icons/Icons'
import { ThemeContext } from '../../theme/ThemeContext'
const { Option } = Select

export const InventoryChangeQuery = (props: {
  exportLoading: any
  loading?: any
  onValueChange: (queries: InventoryChangeParams) => void
  outClued: () => void
  inClued: () => void
}) => {
  const dispatch = useDispatch()

  const location: any = useLocation()

  const [form] = Form.useForm()

  const [popoverForm] = Form.useForm()

  const theme = useContext(ThemeContext)

  const [open, setOpen] = useState(false)

  const durgsystemData = useSelector(selectStorage)

  const userData = useSelector(sleectUserData)

  const tenantCategory = useSelector(selectTenantCategory)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  )

  useEffect(() => {
    dispatch(getStorage({ current: 1 }))
    dispatch(getDepartment({ current: 1, size: 1000, state: 1 }))
    form.setFieldsValue({
      [DateRangeFieldName]: DateRangeType.Today,
      timeHead: head,
      timeTail: tail,
    })
  }, [])

  useEffect(() => {
    if (Object.keys(storageParams).length) {
      form.setFieldsValue({
        ...storageParams,
        registrationTimeTail: storageParams.createTimeEnd,
        registrationTimeHead: storageParams.createTimeStart,
        // param: '', // 防止缓存数据输入
      })
      popoverForm.setFieldsValue({
        batchNo: storageParams.batchNo || '',
      })
    } else {
      const [head, tail] = getDateRange(DateRangeType.Today)
      form.setFieldsValue({
        [DateRangeFieldName]: DateRangeType.Today,
        timeHead: head,
        timeTail: tail,
      })
    }
    form.submit()
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(fs: any) => {
        if (!fs?.registrationTimeTail && fs?._dateRange == 6) {
          return
        }
        const storehouseName =
          (durgsystemData.find(
            (d: any) => d.storehouseId === fs.storehouseId
          ) as any)?.storehouseName || ''
        const userName =
          (userData.find((u: any) => u.id === fs.userId) as any)?.name || ''
        props.onValueChange({
          ...fs,
          ...popoverForm.getFieldsValue(),
          current: 1,
          createTimeEnd: fs.registrationTimeTail,
          createTimeStart: fs.registrationTimeHead,
          registrationTimeTail: undefined,
          registrationTimeHead: undefined,
          storehouseName: storehouseName || undefined,
          userName: userName || undefined,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='name' noStyle>
            <Input
              placeholder='请输入搜索关键词'
              allowClear
              prefix={<SearchOutlined />}
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='vendorName' noStyle>
            <Input
              placeholder='供应商'
              allowClear
              prefix={<SearchOutlined />}
              onChange={form.submit}
            />
          </Form.Item>
          <Form.Item name='storehouseId' noStyle>
            <Select
              placeholder='库房名称'
              allowClear
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                form.submit()
              }}
            >
              {durgsystemData.map((v: any, i) => {
                return (
                  <Option value={v.storehouseId} key={i}>
                    {v.storehouseName}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          {tenantCategory == 1 ? (
            <Form.Item name='category' noStyle>
              <Select
                allowClear
                placeholder='库房业务'
                dropdownClassName={styles.selectDropdown}
                onChange={() => {
                  form.submit()
                }}
              >
                {Categories.map((v) => {
                  return (
                    <Option value={v} key={v}>
                      {CategoryName(v)}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item name='category' noStyle>
              <Select
                allowClear
                placeholder='库房业务'
                dropdownClassName={styles.selectDropdown}
                onChange={() => {
                  form.submit()
                }}
              >
                {Categories?.filter(
                  (v) =>
                    ![
                      Category.SLYW,
                      Category.LSDBCK,
                      Category.CGYW,
                      Category.CGTHYW,
                      Category.FDTHYW,
                      Category.ZDTHYW,
                    ].includes(v)
                ).map((v) => {
                  return (
                    <Option value={v} key={v}>
                      {CategoryName(v)}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          )}
          <Form.Item name='flag' noStyle>
            <Select
              placeholder='合并批次'
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                form.submit()
              }}
            >
              <Option value={0}>不合并</Option>
              <Option value={1}>合并</Option>
            </Select>
          </Form.Item>
          <Form.Item name='userId' noStyle>
            <Select
              showSearch
              placeholder='业务人员'
              allowClear
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                form.submit()
              }}
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='' noStyle>
            <DateSelect
              placeholder='发生时间'
              style={{ width: '8rem' }}
              onChange={() => {
                form.submit()
              }}
              labelPrefix=''
              namePrefix='registrationTime'
              allowClear={false}
            />
          </Form.Item>
          <Popover
            visible={open}
            overlayClassName={styles.formQueryPopover}
            content={
              <>
                <Form
                  form={popoverForm}
                  onFinish={(val) => {
                    form.submit()
                    setOpen(false)
                  }}
                >
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                      批次号：
                    </Col>
                    <Col>
                      <Form.Item label='' name='batchNo'>
                        <Input placeholder='请输入完整批次号' style={{ width: '240px' }}></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      height: '1px',
                      background: '#f0f0f0',
                      marginTop: '10px',
                    }}
                  ></Row>
                  <Space
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      marginTop: '10px',
                    }}
                  >
                    <Button
                      size='middle'
                      type={'ghost'}
                      onClick={() => {
                        setOpen(false)
                      }}
                    >
                      取消
                    </Button>
                    <Button size='middle' type='primary' htmlType='submit'>
                      确定
                    </Button>
                  </Space>
                </Form>
              </>
            }
            title=''
            trigger='click'
            placement='bottom'
            onVisibleChange={(v) => {
              setOpen(v)
            }}
          >
            <Form.Item name='' initialValue={'筛选'} noStyle>
              <Button
                style={{
                  color: theme.tc2,
                  width: '78px',
                  textAlign: 'left',
                  // overflow: 'hidden',
                  // textOverflow: 'ellipsis',
                }}
                icon={
                  <FilterIconOutlined
                    style={{
                      width: '14px',
                      height: '14px',
                      position: 'relative',
                      top: 2,
                      left: -2,
                      color: '#666',
                    }}
                  />
                }
                onClick={() => {
                  setOpen(true)
                }}
              >
                筛选
              </Button>
            </Form.Item>
          </Popover>
          <Button type='primary' htmlType='submit' loading={props?.loading}>
            查询
          </Button>
        </Space>
        <Space>
          <Button type='primary' onClick={() => props.inClued()}>
            导入
          </Button>
          <Button type='primary' onClick={() => props.outClued()} loading={props.exportLoading}>
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
